/**
 * Auth types for Bastion applications
 */

import type { User as SupabaseUser, Session as SupabaseSession } from '@supabase/supabase-js';

/**
 * User object - either authenticated via Supabase or a guest
 */
export interface User {
  id: string;
  email: string | null;
  name: string | null;
  avatarUrl: string | null;
  isGuest: boolean;
}

/**
 * Auth session information
 */
export interface AuthSession {
  user: User;
  accessToken: string | null;
  expiresAt: number | null;
}

/**
 * Auth state for stores
 */
export interface AuthState {
  user: User | null;
  session: AuthSession | null;
  isLoading: boolean;
  isOnline: boolean;
  error: string | null;
}

/**
 * Convert a Supabase user to our User type
 */
export function fromSupabaseUser(supabaseUser: SupabaseUser): User {
  return {
    id: supabaseUser.id,
    email: supabaseUser.email || null,
    name: supabaseUser.user_metadata?.full_name || supabaseUser.user_metadata?.name || null,
    avatarUrl: supabaseUser.user_metadata?.avatar_url || null,
    isGuest: false,
  };
}

/**
 * Convert a Supabase session to our AuthSession type
 */
export function fromSupabaseSession(
  supabaseSession: SupabaseSession,
  user: User
): AuthSession {
  return {
    user,
    accessToken: supabaseSession.access_token,
    expiresAt: supabaseSession.expires_at || null,
  };
}

